import {useCallback, useState} from 'react';

/**
 * Identical API to Chakra UI's useBoolean:
 *
 * const [value, { on, off, toggle }] = useBoolean(initialValue)
 */
export const useBoolean = (initialValue = false) => {
	const [value, setValue] = useState<boolean>(initialValue);

	const on = useCallback(() => setValue(true), []);
	const off = useCallback(() => setValue(false), []);
	const toggle = useCallback(() => setValue(v => !v), []);

	return [value, {on, off, toggle}] as const;
};
